export default __webpack_public_path__ + "static/media/emotionDecH5.e03ffea1.png";